import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ModalComponent} from '../modal/modal.component';
import {ChangeSizeComponent} from '../modal/change-size/change-size.component';
import {SelectBackgroundComponent} from '../modal/select-background/select-background.component';
import {GlobalConstants} from '../../common/global-variable';
import { HttpClient } from '@angular/common/http';
import { Flags } from '../../common/flags'

import { ApiService } from '../../service/api.service';
import { ProgressComponent } from '../modal/progress/progress.component';

declare var d3 : any;
var singleModal : any;
var boxSize : any;
var background : any;

var imgSize = [3000, 2500, 2000, 1500, 1000, 500]
var textSize = [500,260,220,180,140,100,70,50]

var empty_node_setting : string;
var text_align : string;
var name_text_align : string;

var node_width
var name_height = {}
var birth_height = {}
var marriage_height = {}
var death_height = {}
var note_height = {}

var imgSizeGroup = {
    'A0': [2000, 1700, 1500, 1350, 1200, 1000],
    'A1': [1600, 1400, 1250, 1100, 1000, 800],
    'A2': [1400, 1200, 1050, 900, 800, 600],
    // 'A3': [1200, 1000, 850, 700, 600, 400],
    // 'A4': [1000, 700, 500, 400, 400, 200],
    // 'Custom': [2000, 1700, 1500, 1350, 1200, 1000],
}
var flagSizeGroup = {
    'A0': [800, 700, 600, 500, 450, 400],
    'A1': [700, 600, 500, 450, 400, 350],
    'A2': [650, 550, 450, 400, 350, 300],
    // 'A3': [500, 400, 300, 200, 100, 100],
    // 'A4': [300, 200, 150, 120, 80, 80],
    // 'Custom': [800, 700, 600, 500, 400, 400],
}
var textSizeGroup = {
    'A0': [250,250,200,200,200,150,150,100,60,70],
    'A1': [200,180,180,180,150,100,100,70,50,50],
    'A2': [180,150,150,110,110,80,70,70,50,50],
    // 'A3': [180,150,150,110,80,50,50,50,50,50],
    // 'A4': [150,130,110,90,70,50,50,50,50,50],
    // 'Custom': [250,200,200,180,140,100,70,50],
}
    
var start_x = 0;
var start_y = 0;

var flagSize

var papertype;
var manColor, womanColor;
var borderColor, borderWidth;
var backOpacity, nodeOpacity;
var maxGeneration, treeWidth, treeHeight;
var femaleNodeColor, maleNodeColor, borderRadius;

var birthSetting, marriageSetting, deathSetting;
var flag_setting, profile_setting, global_padding, warning_setting;

var maleAvatar = [GlobalConstants.male_1, GlobalConstants.male_2, GlobalConstants.male_3, GlobalConstants.male_4,
    GlobalConstants.male_5, GlobalConstants.male_6, GlobalConstants.male_7, GlobalConstants.male_8, GlobalConstants.male_9,
    GlobalConstants.male_10, GlobalConstants.male_11, GlobalConstants.male_12];

var femaleAvatar = [GlobalConstants.female_1, GlobalConstants.female_2, GlobalConstants.female_3, GlobalConstants.female_4,
    GlobalConstants.female_5, GlobalConstants.female_6, GlobalConstants.female_7, GlobalConstants.female_8, GlobalConstants.female_9,
    GlobalConstants.female_10, GlobalConstants.female_11, GlobalConstants.female_12];

function spliteText(string, length, ignore=0){
        
    var list = string.split(" ");
    var temp = ""
    var result = []
    for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if(result==[]){
            if(temp.length + element.length < length-ignore){
                temp += element+" ";
            } else {
                result.push(temp)
                temp = element
            }
        } else {
            if(temp.length + element.length < length){
                temp += element+" ";
            } else {
                result.push(temp)
                temp = element
            }
        }
        
        if(index >= list.length-1){
            result.push(temp)
        }
    }
    return result;
    
}

@Component({selector: 'app-double', templateUrl: './double.component.html', styleUrls: ['./double.component.scss']})
export class DoubleComponent implements OnInit {

    type : any;
    nodeinfos = {};
    coupleinfos = {};
    _id : any;
    wife: any;
    relation = {};
    p_type
    m_Color
    w_Color
    m_b_Color
    w_b_Color
    b_Color
    b_Width
    back_Opacity
    node_Opacity
    max_generation
    cornerRound
    empty_node
    text_align
    name_text_align
    birthSetting
    marriageSetting
    deathSetting
    partner_setting
    children_setting
    flag_setting
    profile_setting
    global_padding
    warning_setting

    constructor(public matDialog : MatDialog, public ApiService: ApiService, public http: HttpClient) {}

    selectBackground(){
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        dialogConfig.id = "select-background-component";
        dialogConfig.height = "90vh";
        dialogConfig.data = localStorage.getItem('direction')

        const modalDialog = singleModal.open(SelectBackgroundComponent, dialogConfig);
        modalDialog.afterClosed().subscribe((result) => {
            this.addbackground(result)
        });
    }

    parentRelation(parent, depth, temp = []) {
        if(depth >= (maxGeneration-1)) return;
        if (this.nodeinfos[parent.father] || this.nodeinfos[parent.mother]) {

            if (this.nodeinfos[parent.father]) {
                this.nodeinfos[parent.father]['c_fam'] = parent.famc;
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.father])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
                buf['id'] = 'fake_'+this.nodeinfos[parent.mother]['id']
                this.nodeinfos[parent.id]['father'] = buf['id']
                buf['c_fam'] = parent.famc
                buf['marriage'] = this.nodeinfos[parent.mother]['marriage']
                buf['sex'] = 'M'
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            if (this.nodeinfos[parent.mother]) {
                this.nodeinfos[parent.mother]['c_fam'] = parent.famc;
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[parent.mother])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
                buf['id'] = 'fake_'+this.nodeinfos[parent.father]['id']
                this.nodeinfos[parent.id]['mother'] = buf['id']
                buf['c_fam'] = parent.famc
                buf['marriage'] = this.nodeinfos[parent.father]['marriage']
                buf['sex'] = 'F'
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            
        } else {
            let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
            buf['id'] = 'fake_father_'+parent['id']
            this.nodeinfos[parent.id]['father'] = buf['id']
            buf['c_fam'] = 'fake_fam_' + parent['id']
            buf['sex'] = 'M'
            this.nodeinfos[buf['id']] = buf
            temp.push(JSON.parse(JSON.stringify(buf)));

            let buff = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
            buff['id'] = 'fake_mother_'+parent['id']
            this.nodeinfos[parent.id]['mother'] = buff['id']
            buff['c_fam'] = 'fake_fam_' + parent['id']
            buff['sex'] = 'F'
            this.nodeinfos[buff['id']] = buff
            temp.push(JSON.parse(JSON.stringify(buff)));
        }
        parent._parents = temp;
        if (parent._parents[0]) {
            this.parentRelation(parent._parents[0], depth+1);
        }
        if (parent._parents[1]) {
            this.parentRelation(parent._parents[1], depth+1);
        }
    }

    childrenRelation(child, depth, temp = []) {
        if(depth >= (maxGeneration-1)) return;
        if (this.nodeinfos[child.father] || this.nodeinfos[child.mother]) {

            if (this.nodeinfos[child.father]) {
                this.nodeinfos[child.father]['c_fam'] = child.famc;
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[child.father])));
            }else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
                buf['id'] = 'fake_'+this.nodeinfos[child.mother]['id']
                this.nodeinfos[child.id]['father'] = buf['id']
                buf['c_fam'] = child.famc
                buf['marriage'] = this.nodeinfos[child.mother]['marriage']
                buf['sex'] = 'M'
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            if (this.nodeinfos[child.mother]) {
                this.nodeinfos[child.mother]['c_fam'] = child.famc;
                temp.push(JSON.parse(JSON.stringify(this.nodeinfos[child.mother])));
            } else {
                let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
                buf['id'] = 'fake_'+this.nodeinfos[child.father]['id']
                this.nodeinfos[child.id]['mother'] = buf['id']
                buf['c_fam'] = child.famc
                buf['marriage'] = this.nodeinfos[child.father]['marriage']
                buf['sex'] = 'F'
                this.nodeinfos[buf['id']] = buf
                temp.push(JSON.parse(JSON.stringify(buf)));
            }
            
        } else {
            let buf = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
            buf['id'] = 'fake_father_'+child['id']
            this.nodeinfos[child.id]['father'] = buf['id']
            buf['c_fam'] = 'fake_fam_' + child['id']
            buf['sex'] = 'M'
            this.nodeinfos[buf['id']] = buf
            temp.push(JSON.parse(JSON.stringify(buf)));

            let buff = JSON.parse(JSON.stringify(GlobalConstants.node_structure)) ;
            buff['id'] = 'fake_mother_'+child['id']
            this.nodeinfos[child.id]['mother'] = buff['id']
            buff['c_fam'] = 'fake_fam_' + child['id']
            buff['sex'] = 'F'
            this.nodeinfos[buff['id']] = buff
            temp.push(JSON.parse(JSON.stringify(buff)));
        }
        child._children = temp;
        if (child._children[0]) {
            this.childrenRelation(child._children[0], depth+1);
        }
        if (child._children[1]) {
            this.childrenRelation(child._children[1], depth+1);
        }
    }

    addchildren(direction_t){
        node_width = treeHeight/Math.pow(2, (maxGeneration-2))
        var direction = parseInt(localStorage.getItem('direction'));
        var children = this.coupleinfos[this._id].children
        
        var child = this.nodeinfos[children[0]]

        for (let index = 0; index < children.length; index++) {
            const element = children[index];
            if(index < children.length-1){
                let temp = [];
                temp.push(this.nodeinfos[children[index+1]])
                
                this.nodeinfos[children[index]]['_child'] = temp
            }            
        }

        var childrenTree = d3
            .layout
            .tree()
            .nodeSize([treeHeight/Math.pow(2, (maxGeneration-2)), imgSize[0]+4*textSize[0]])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._child;
            });

        draw(childrenTree, child, 'children', direction)

        function draw( tree, root, displayClass, direction){
            var svg = d3.select('body').select('g')
            
            var nodes = tree.nodes(root);
            var node = svg
                .selectAll("g.person." + displayClass)
                .data(nodes);

                var nodeEnter = node
                .enter()
                .append("g")
                .attr("class", "person " + displayClass)
                .on('click', editModal);
            
            function editModal(d) {
                
                const dialogConfig = new MatDialogConfig();
                // The user can't close the dialog by clicking outside its body
                dialogConfig.disableClose = true;
                dialogConfig.id = "modal-component";
                if(d.depth > 3 && d.depth <= 6) dialogConfig.height = "70vh";
                else if(d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
                else if(d.depth > 8) dialogConfig.height = "20vh";
                else dialogConfig.height = "90vh";
                dialogConfig.width = "500px";
                dialogConfig.data = d
        
                const modalDialog = singleModal.open(ModalComponent, dialogConfig);
                modalDialog.afterClosed().subscribe(() => {
                    location.reload()
                });
            };

            nodeEnter
                .append("rect")
                .attr({
                    x: function(d){
                        return 0
                    },
                    y: function(d){
                        return 0
                    },
                    width: function(d){
                        return 0
                    },
                    height: function(d){
                        return 0
                    }, 
                    stroke: borderColor,    
                    fill: function(d) { 
                        if(d.sex=='M') return maleNodeColor
                        else return femaleNodeColor 
                    },    
                    "rx": borderRadius,
                    "stroke-width": function(d) { return borderWidth; },
                    display: function(d){
                        if(d.id && d.id.substring(0, 5) == 'fake_'){
                            return empty_node_setting
                        }
                    },
                })

         //image
         node
         .append('image')
         .attr({
             'class': 'avatar',
             'xlink:href': function (d) {
                 if(d.url ==""){
                     if(d.sex=='M'){
                         return maleAvatar[Math.floor(Math.random() * Math.floor(12))]
                     }else{
                         return femaleAvatar[Math.floor(Math.random() * Math.floor(12))]
                     }
                 } else{
                     return d.url;
                 }
             },
             'width': function(d){   
                return imgSize[1];             
             },
             'height': function(d){
                return imgSize[1];
             },
             "x": function(d){                
                    return imgSize[1] * (-0.5) - flagSize[1]/2 - 100;
             },
             "display": function(d){
                 if(profile_setting != "SHOW"){
                     return "none"
                 }
                 if(d.depth > 5){
                     return "none"
                 }
                 if(d.avatar_setting != "SHOW"){
                    return "none"
                }
                 
             },

         }).each(function(d){
             d.height = this.getBBox().height
             d.width = this.getBBox().width + flagSize[1] + 200
         })

         node
         .append('image')
         .attr({
             'class': 'flag',
             'xlink:href': function (d) {
                 if(!d.country || d.country ==""){
                     return Flags.flags['Sweden']
                 } else if(d.country == "NoFlag"){
                     return Flags.flags['Sweden']
                 }
                 else{
                     return Flags.flags[d.country]
                 }
             },
             'width': function(d){    
                return flagSize[1]
             },
             'height': function(d){
                return flagSize[1]
             },
             "x": function(d){      
                return imgSize[1]/2 -flagSize[1]/2 + 100        
             },

             "display": function(d){
                if(profile_setting != "SHOW"){
                    return "none"
                }
                if(flag_setting!="SHOW"){
                    return "none"
                }
                if(d.country == "NoFlag"){
                    return "none"
                }
                if(d.avatar_setting != "SHOW"){
                    return "none"
                }
                 if(d.id.substring(0, 5) == 'fake_'){
                     return empty_node_setting
                 }
                 
             },

         })

          //first name and last name
          node
          .append("text")
          .attr({
              "dx": 0,
              'class': 'name',
              'fill': function(d){
                  if(d.sex=='M') return manColor
                  else return womanColor
              },
              "display": function(d){
                  if(d.id.substring(0, 5) == 'fake_'){
                      return empty_node_setting
                  }
              },
              'font-size': function(d){
                 return textSize[1];
              }
          })
          .each(function(d){
              let font_size = textSize[1]
              let name = (d.firstName ?d.firstName : 'n/a' ) + " " + (d.lastName ? d.lastName : 'n/a' )
              
              let length = Math.floor((node_width+500*maxGeneration)/ font_size *1.6)
              d3.select(this)
              .append("tspan")
              .text( function(){
                  return name.substring(0, length);
              })
              .attr({
                  'class': 'name_span',
              })
 
              for (let i = 0; i < (name.length)/length; i++) {
                d3.select(this)
                .append("tspan")
                .text(function(){
                    if(length < name.length)
                        return name.substring(length*(i+1), length*(i+2));
                })
                .attr({
                    x: 0,
                    dy: '1em',
                    'class': 'name_span',
                }) 
            }
 
              if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
              d.height = this.getBBox().height + d.height
              name_height[d.id + d.depth] = this.getBBox().height
             });
 
          node
             .append("text")
             .attr({
                 "dx": 0,
                 'class': 'birth',
                 'fill': function(d){
                     if(d.sex=='M') return manColor
                     else return womanColor
                 },
                 'font-size': function(d){
                     return textSize[1];
                 },
                 "display": function(d){
                     if(d.depth > 8){
                         return "none"
                     }
                     if(d.id.substring(0, 5) == 'fake_'){
                         return empty_node_setting
                     }
                     
                 },
             })
             .each(function(d){
                 let place = d.birth ? d.birth.place : "n/a";
 
                 let font_size = textSize[1]
 
                 let birth_info =d.birthday + ", " + place
 
                 let length = Math.floor((node_width+500*maxGeneration)/ font_size *1.6)
                 
                    d3.select(this)
                    .append("tspan")
                    .text( function(){
                        return "Born: ";
                    })
                    .attr({
                        'font-weight': "bold"
                    })
                    d3.select(this)
                    .append("tspan")
                    .text( function(){
                        return birth_info.substring(0, length-6);
                    }).attr({
                        'class': "nextString",
                    })

                    for (let i = 0; i < (birth_info.length+6)/length; i++) {
                        d3.select(this)
                        .append("tspan")
                        .text(function(){
                            if(length < birth_info.length+6)
                                return birth_info.substring(length*(i+1)-6, length*(i+2)-6);
                        })
                        .attr({
                            x: 0,
                            dy: '1em',
                        }) 
                    }
 
                 if(birthSetting != "none" && d.depth <= 8){
                     if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                     d.height = this.getBBox().height + d.height
                 }
                 if(!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height     
             });
         // death day and place
         node
         .append("text")
         .attr({
             "dx": 0,
             'class': 'death',
             'fill': function(d){
                 if(d.sex=='M') return manColor
                 else return womanColor
             },
             'font-size': function(d){
                 return textSize[1];
             },
             "display": function(d){
                 return 'block'
             },
         })

         .each(function(d){
             let place = d.death ? d.death.place : "n/a";
             let font_size = textSize[1]
 
             let death_info = d.deathday + ", " + place
 
             let length = Math.floor((node_width+500*maxGeneration)/ font_size *1.6)
             
                d3.select(this)
                .append("tspan")
                .text( function(){
                    return "Deceased: ";
                })
                .attr({
                    'font-weight': "bold"
                })
                d3.select(this)
                .append("tspan")
                .text( function(){
                    return death_info.substring(0, length-9);
                }).attr({
                    'class': "nextString",
                })
                for (let i = 0; i < (death_info.length+9)/length; i++) {
                    d3.select(this)
                    .append("tspan")
                    .text(function(){
                        if(length < death_info.length+9)
                            return death_info.substring(length*(i+1)-9, length*(i+2)-9);
                    })
                    .attr({
                        x: 0,
                        dy: '1em',
                    }) 
                }

             if(deathSetting!="none" && d.depth <= 8){
                 if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                 if(d.depth <= 8)d.height = this.getBBox().height + d.height 
             } 
             death_height[d.id] = this.getBBox().height
         });

        
 
         node.selectAll("tspan").attr({
             dx: function(d){
                 switch (text_align) {
                     case 'middle':
                         return 0;
                     case 'start':
                         return (-1)*d.width/2;                
                     default:
                         return d.width/2; 
                 }
             },
             "text-anchor": text_align,
             opacity: nodeOpacity,
         }) 
 
         node.selectAll(".name_span").attr({
             dx: function(d){
                 switch (name_text_align) {
                     case 'middle':
                         return 0;
                     case 'start':
                         return (-1)*d.width/2;                
                     default:
                         return d.width/2; 
                 }
             },
             "text-anchor": name_text_align
         })

         node.selectAll(".nextString").attr({
            dx: 0
        })

 
         node.selectAll(".avatar").attr({
             y: function(d){
                 return (-1)*d.height/2
             },
             opacity: nodeOpacity,
         })

         node.selectAll(".flag").attr({
            y: function(d){
                return (-1)*d.height/2
            },
            opacity: nodeOpacity,
        })
 
         node.selectAll(".name").attr({
             dy: function(d){
                 return (-1)*d.height/2 + imgSize[1] + textSize[1]
             },
         }) 
 
         node.selectAll(".birth").attr({
             dy: function(d){
                 return (-1)*d.height/2 + imgSize[1] + textSize[1] + name_height[d.id + d.depth]
             },
             dx: function(d){
                 switch (text_align) {
                     case 'middle':
                         return 0;
                     case 'start':
                         return (-1)*d.width/2;                
                     default:
                         return d.width/2; 
                 }
             },
             display: function(d){
                 if(birthSetting=="none"){
                     return "none"
                 }
             },
             "text-anchor": text_align
         }) 
 
         node.selectAll(".death").attr({
             dy: function(d){
                 var temp = imgSize[1] + textSize[1] + name_height[d.id + d.depth] 
                 
                 if(birthSetting != 'none'){
                     temp += birth_height[d.id + d.depth]
                 }
 
                 return (-1)*d.height/2 + temp
             },
             display: function(d){
                 if(deathSetting=="none"){
                     return "none"
                 }
             },
         })  
        
        var nodeUpdate = node
                .transition()
                .attr("transform", function (d) {
                    
                    switch (direction_t) {
                        case 1:
                            return "translate(" +(d.y+2.5*imgSize[0]) + "," +  d.x + ")";
                        default:
                            return "translate(" + d.x + "," +  (d.y + (imgSize[0] + 4 * textSize[0])) + ")";
                    }

                });
        
        nodeUpdate
            .select("rect")
            .attr({
                x: function(d){
                    return -(d.width*1.1 + 20)/2;
                },
                y: function(d){
                    return -(d.height + 20)/2;
                },
                width: function(d){
                    return d.width*1.1 + 20;
                },
                height: function(d){
                    return d.height + 20;
                },
            });

        }
        
        
    }

    addbackground(data) {
        d3
            .select('svg')
            .select('g')
            .select('image')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0) 
        d3
            .select('svg')
            .select('g')
            .select('rect')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0) 

        var svgt = document.querySelector('svg');
        const gg = svgt.querySelector('g')
        boxSize = gg.getBBox()
         

        if(data[0] != '#'){
            background = data           

            var xhr = new XMLHttpRequest();       
            xhr.open("GET", background, true); 
            xhr.responseType = "blob";
            xhr.onload = function (e) {
                var reader = new FileReader();
                reader.onload = function(event) {
                    var res = event.target.result;
                    let image = res;
                    var img = new Image();
                    img.src = image.toString();
                    img.onload = async function () {

                        
                        let w2 = boxSize.width * ( 1 + 0.01 * parseFloat(global_padding));
                        let h2 = boxSize.height * ( 1 + 0.01 * parseFloat(global_padding));

                        let w1 = img.width;
                        let h1 = img.height;

                        let rate = Math.max(w2/w1, h2/h1)

                        
    
                        let x = boxSize.x - (w1 * rate - boxSize.width) / 2;
                        let y = boxSize.y - (h1 * rate - boxSize.height) / 2;
    
                        d3
                            .select('svg')
                            .select('g')
                            .select('image')
                            .attr('xlink:href', image)
                            .attr('width', w1 * rate)
                            .attr('height', h1 * rate)
                            .attr('x', x)
                            .attr('y', y)     
                        
                    }
                }
                var file = this.response;
                reader.readAsDataURL(file)
            };
            xhr.send()
        } else if(data[0] === '#'){
            var backgroundColor = data;
            d3
            .select('svg')
            .select('g')
            .select('rect')
            .attr('fill', backgroundColor)
            .attr('width', boxSize.width * 1.05)
            .attr('height', boxSize.heigh * 1.05)
            .attr('x', boxSize.x - boxSize.width * 0.025)
            .attr('y', boxSize.y - boxSize.heigh * 0.025)  
        }
        
    }

    generate() {   
        
        var svg = document.querySelector('svg'); // clone your original svg
        var g = svg.querySelector('g') // select the parent g

        d3.select('body')
        .select('svg')
        .append('text')
        .attr({
            "x": 0,
            "y": 0,
            "text-anchor": "middle",
            'class': 'watermark',
            'fill': function(d){
                return '#000'
            },
            'font-size': function(d){
                switch (papertype) {
                    case "A1":
                        return 400;
                    case "A2":
                        return 300;
                    case "A3":
                        return 200;
                    case "A4":
                        return 100;
                    case "A0":
                        return 500;
                    default:
                        return 500;
                }
            },
            "transform": "rotate(-45) translate("+ 0 +", "+g.getBBox().height/2*0.1+")",
            'opacity': 0.2
        })
        .text(function (d) {
            return "";
        })

        svg = document.querySelector('svg'); // clone your original svg
        g = svg.querySelector('g') // select the parent g

        g.setAttribute('transform', "translate(" + Math.abs(g.getBBox().x/10 - 50) + "," + Math.abs(g.getBBox().y/10 - 50) + ") scale(0.1)") // clean transform
        svg.setAttribute('width', (g.getBBox().width/10 + 100).toString()) // set svg to be the g dimensions
        svg.setAttribute('height', (g.getBBox().height/10 + 100).toString())
        const svgAsXML = (new XMLSerializer).serializeToString(svg);
        const svgData = `data:image/svg+xml,${encodeURIComponent(svgAsXML)}`
        const link = document.createElement("a");
        document
            .body
            .appendChild(link);
        link.setAttribute("href", svgData);
        link.setAttribute("download", "image.svg");
        link.click();
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;

        this.matDialog.open(ProgressComponent, dialogConfig);

        this.ApiService.generatepdf(svgAsXML)
        .pipe().subscribe((data:any)=> {
            
            this.matDialog.closeAll()
            d3.select('.watermark').remove();
        })
    }

    selectTreeType(direction){
        d3
            .select('svg')
            .remove()
        localStorage.setItem("direction", direction);   
        
        this.fromCenterTree(direction)                
    }

    fromCenterTree(direction_t) {
        node_width = treeWidth/(2*maxGeneration-1)
        this.relation = [];
        
        var father_relation = this.nodeinfos[this.coupleinfos[this._id]['husb']]
        father_relation['c_fam'] = this.coupleinfos[this._id].id;
        this.parentRelation(this.nodeinfos[this.coupleinfos[this._id]['husb']], 0);

        var mother_relation = this.nodeinfos[this.coupleinfos[this._id]['wife']]
        mother_relation['c_fam'] = this.coupleinfos[this._id].id;
        this.childrenRelation(this.nodeinfos[this.coupleinfos[this._id]['wife']], 0)

        this.relation['_children'] = [];
        this.relation['_parents'] = [];
        this.relation['_children'].push(mother_relation);
        this.relation['_parents'].push(father_relation);


        var ancestorRoot,
            descendantRoot;

        var duration = 750;
        var zoom = d3
            .behavior
            .zoom()
            .scaleExtent([.01, 10])
            .on('zoom', function () {
                svg.attr("transform", "translate(" + d3.event.translate + ") scale(" + d3.event.scale/10 + ")");
            })
            .translate([400, 200]);

        var svg = d3
            .select('body')
            .append('svg')
            .attr('width', '100%')
            .attr('height', '100%')
            .call(zoom)
            .append('g')
            .attr("transform", "translate(400,200)")
            .attr("padding", 100);

        svg.append('rect')
            .attr({
                width: 0,
                height: 0,
                x: 0,
                y: 0
            })

        svg.append('image')
            .attr('width', 0)
            .attr('height', 0)
            .attr('x', 0)
            .attr('y', 0)
            .attr('opacity', backOpacity)

        svg
            .append('style')
            .text(`
            text {
            }
            .person {
                cursor: pointer;
            }
            
            .link {
                fill: none;
                stroke: #ccc;
                stroke-width: 20px;
            }`);

        var ancestorsTree = d3
            .layout
            .tree()
            .nodeSize([treeHeight/Math.pow(2, (maxGeneration-2)), treeWidth/(2*maxGeneration-1)])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._parents;
            });
        var descendantsTree = d3
            .layout
            .tree()
            .nodeSize([treeHeight/Math.pow(2, (maxGeneration-2)), treeWidth/(2*maxGeneration-1)])
            .separation(function () {
                return .5;
            })
            .children(function (person) {
                return person._children;
            });
        ancestorRoot = rootProxy(this.relation);
        descendantRoot = rootProxy(this.relation);

        drawAncestors();
        drawDescendants();

        function rootProxy(root) {
            return {
                firstName: root.firstName,
                lastName: root.lastName,
                country: root.country,
                sex: root.sex,
                birth: root.birth,
                death: root.death,
                marriage: root.marriage,
                birthday: root.birthday,
                deathday: root.deathday,
                url: root.url,
                id: root.id,
                x0: 0,
                y0: 0,
                _children: root._children,
                _parents: root._parents
            };
        }

        function drawAncestors() {
            draw(ancestorsTree, ancestorRoot, 'ancestor', 1);
        }

        function drawDescendants() {
            draw(descendantsTree, descendantRoot, 'descendant', -1);
        }

        function draw( tree, root, displayClass, direction) {                      
            
            var nodes = tree.nodes(root);
            for (let index = 0; index < nodes.length; index++) {
                const element = nodes[index];
                const half = (maxGeneration-2)/2;
                if(element.depth != 0){
                    nodes[index].y += 500*(half * element.depth - (Math.pow(element.depth-1, 2) + element.depth+1)/2)
                }
            }
            var links = tree.links(nodes);            

            var link = svg
                .selectAll("path.link." + displayClass)
                .data(links);
            link
                .enter()
                .append("path")
                .attr({
                    "class": "link " + displayClass,
                    "display": function(d){
                        if(d.target.id.substring(0, 5) == 'fake_'){
                            return empty_node_setting
                        }else{
                            return "block"
                        }
                    }
                })
            link
                .transition()
                .duration(duration)
                .attr("d", function (d) {
                    return elbow(d, direction);
                });

            var node = svg
                .selectAll("g.person." + displayClass)
                .data(nodes);

            var nodeEnter = node
                .enter()
                .append("g")
                .attr("class", "person " + displayClass)
                .on('click', editModal);
            
            function editModal(d) {
                
                const dialogConfig = new MatDialogConfig();
                // The user can't close the dialog by clicking outside its body
                dialogConfig.disableClose = true;
                dialogConfig.id = "modal-component";
                if(d.depth > 3 && d.depth <= 6) dialogConfig.height = "70vh";
                else if(d.depth > 6 && d.depth <= 8) dialogConfig.height = "50vh";
                else if(d.depth > 8) dialogConfig.height = "20vh";
                else dialogConfig.height = "90vh";
                dialogConfig.width = "500px";
                dialogConfig.data = d
        
                const modalDialog = singleModal.open(ModalComponent, dialogConfig);
                modalDialog.afterClosed().subscribe(() => {
                });
            };

            nodeEnter
                .append("rect")

            var nodeUpdate = node
                .transition()
                .duration(duration)
                .attr("transform", function (d) {
                    switch (direction_t) {
                        case 3:
                            return "translate(" + (direction * d.y) + "," + d.x + ")";
                        default:
                            return "translate(" + d.x + "," + (direction * d.y) + ")";
                    }

                });


 //image
            node
                .append('image')
                .attr({
                    'class': 'avatar',
                    'xlink:href': function (d) {
                        if(d.url ==""){
                            if(d.sex=='M'){
                                return maleAvatar[Math.floor(Math.random() * Math.floor(12))]
                            }else{
                                return femaleAvatar[Math.floor(Math.random() * Math.floor(12))]
                            }
                        } else{
                            return d.url;
                        }
                    },
                    'width': function(d){    
                        if(d.depth < 6){
                            return imgSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    'height': function(d){
                        if(d.depth < 6){
                            return imgSize[d.depth]
                        } else {
                            return 0
                        }
                    },
                    "x": function(d){      
                        if(d.depth < 6){
                            if(flag_setting!="SHOW" || d.country=="NoFlag" || d.depth > 5){
                                return -imgSize[d.depth]/2 - 100
                            }
                            return -imgSize[d.depth]/2 -flagSize[d.depth]/2 - 100
                        } else {
                            return 0
                        }          
                    },
                    "display": function(d){
                        if(profile_setting != "SHOW"){
                            return "none"
                        }
                        if(d.depth == 0) return "none"
                        if(d.depth > 5){
                            return "none"
                        }
                        if(d.avatar_setting != "SHOW"){
                            return "none"
                        }
                        if(d.id && d.id.substring(0, 5) == 'fake_'){
                            return empty_node_setting
                        }
                        
                    },
    
                }).each(function(d){
                    d.height = this.getBBox().height
                    if(d.depth < 6){
                        if(flag_setting!="SHOW" || d.country=="NoFlag" || d.depth > 5){
                            return d.width = this.getBBox().width + 200
                        }
                        return d.width = this.getBBox().width + flagSize[d.depth] + 200
                    } else {
                        return d.width = this.getBBox().width
                    } 
                })

    //flag
            node
            .append('image')
            .attr({
                'class': 'flag',
                'xlink:href': function (d) {
                    if(!d.country || d.country ==""){
                        return Flags.flags['Sweden']
                    } else if(d.country == "NoFlag"){
                        return Flags.flags['Sweden']
                    }
                    else{
                        return Flags.flags[d.country]
                    }
                },
                'width': function(d){    
                    if(d.depth < 6){
                        return flagSize[d.depth]
                    } else {
                        return 0
                    }
                },
                'height': function(d){
                    if(d.depth < 6){
                        return flagSize[d.depth]
                    } else {
                        return 0
                    }
                },
                "x": function(d){      
                    if(d.depth < 6){
                        return imgSize[d.depth]/2 -flagSize[d.depth]/2 + 100
                    } else {
                        return 0
                    }          
                },
                "display": function(d){
                    if(profile_setting != "SHOW"){
                        return "none"
                    }
                    if(flag_setting!="SHOW"){
                        return "none"
                    }
                    if(d.country == "NoFlag"){
                        return "none"
                    }
                    if(d.depth == 0) return "none"
                    if(d.depth > 5){
                        return "none"
                    }
                    if(d.avatar_setting != "SHOW"){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }                    
                },

            })

//first name and last name
            node
            .append("text")
            .attr({
                "dx": 0,
                'class': 'name',
                'fill': function(d){
                    if(d.sex=='M') return manColor
                    else return womanColor
                },
                "display": function(d){
                    if(d.depth == 0) return "none"
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }
                },
                'font-size': function(d){
                    if(d.depth <= 9){
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                }
            })
            .each(function(d){
                let font_size
                if(d.depth < 9){
                    font_size = textSize[d.depth]
                } else {
                    font_size = textSize[9]
                } 
                let name = (d.firstName ?d.firstName : 'n/a' ) + " " + (d.lastName ? d.lastName : 'n/a' )
                
                if(name.includes('n/a')){
                    d.warning = true;
                }
                
                let length
                if(direction_t=='1'){
                    if(d.depth <= 5){
                        length = Math.floor(treeWidth/ Math.pow(2, d.depth-1) / font_size*1)
                    } else {
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                    }
                }else if(d.depth == 0){
                    length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)*1.6
                } else {
                    length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                }

                var res_text = spliteText(name, length);
                for (let index = 0; index < res_text.length; index++) {
                    const element = res_text[index];
                    d3.select(this)
                    .append("tspan")
                    .text(function(){
                        return element;
                    })
                    .attr({
                        x: function(){
                            if(index > 0) return 0
                        },
                        dy: function(){
                            if(index > 0) return '1em'
                        },
                        'class': 'name_span',
                    }) 
                    
                }
                
                if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                d.height = this.getBBox().height + d.height
                name_height[d.id + d.depth] = this.getBBox().height
            });

// birthday and place
            node
            .append("text")
            .attr({
                "dx": 0,
                "text-anchor": "middle",
                'class': 'birth',
                'fill': function(d){
                    if(d.sex=='M') return manColor
                    else return womanColor
                },
                'font-size': function(d){
                    if(d.depth <= 9){
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                "display": function(d){
                    if(d.depth == 0) return "none"
                    if(d.depth > 8){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }
                    
                },
            })
            .each(function(d){
                let place = d.birth ? d.birth.place : "n/a";

                let font_size
                if(d.depth <= 9){
                    font_size = textSize[d.depth]
                } else {
                    font_size = textSize[9]
                } 
                let birth_info = d.birthday + ", " + place

                if(birthSetting!="none" && d.depth <= 8){
                    if(birth_info.includes('n/a') || birth_info.includes('.-') || birth_info.includes('-.')){
                        d.warning = true;
                    }                    
                } 

                if(direction_t=='1'){
                    if(d.depth <= 5){
                        length = Math.floor(treeWidth/ Math.pow(2, d.depth-1) / font_size *1)
                    } else {
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                    }
                }else if(d.depth == 0){
                    length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)*1.6
                } else {
                    length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                }

                if(d.depth < 6){
                    d3.select(this)
                    .append("tspan")
                    .text( function(){
                        return "Born: ";
                    })
                    .attr({
                        'font-weight': "bold"
                    })
                    var res_text = spliteText(birth_info, length, 6);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                            .append("tspan")
                            .text(function(){
                                return element;
                            })
                            .attr({
                                x: function(){
                                    if(index > 0) return 0
                                },
                                dy: function(){
                                    if(index > 0) return '1em'
                                },
                                'class': function(){
                                    if(index == 0) return 'nextString'
                                },
                            }) 
                            
                        }
                    
                } else {
                    d3.select(this)
                    .append("tspan")
                    .text( function(){
                        return "B: ";
                    })
                    .attr({
                        'font-weight': "bold"
                    })
                    var res_text = spliteText(birth_info, length, 3);
                    for (let index = 0; index < res_text.length; index++) {
                        const element = res_text[index];
                        d3.select(this)
                        .append("tspan")
                        .text(function(){
                            return element;
                        })
                        .attr({
                            x: function(){
                                if(index > 0) return 0
                            },
                            dy: function(){
                                if(index > 0) return '1em'
                            },
                            'class': function(){
                                if(index == 0) return 'nextString'
                            },
                        }) 
                        
                    }
                    
                }        
                
                if(birthSetting != "none" && d.depth <= 8){
                    if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                    if(d.depth <= 8) d.height = this.getBBox().height + d.height
                }
                if(!birth_height[d.id + d.depth]) birth_height[d.id + d.depth] = this.getBBox().height      
            });

//marriage day and place
            node
            .append("text")
            .attr({
                "dx": 0,
                'class': 'marriage',
                'fill': function(d){
                    if(d.sex=='M') return manColor
                    else return womanColor
                },
                'font-size': function(d){
                    if(d.depth <= 9){
                        return textSize[d.depth]
                    } else {
                        return textSize[9]
                    }
                },
                "display": function(d){
                    if(d.depth == 0 || d.depth > 6){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }
                    
                },
            })
            .each(function(d){
                if(d.depth != 0 && d.depth <= 6){
                    let marriage_day = getMarriageDay(d);
                    let marriage_place = d.c_fam ? (d.marriage[d.c_fam] ? d.marriage[d.c_fam]['place'] : "n/a") : "n/a";
                    let font_size
                    if(d.depth <= 9){
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    } 
                    let marriage_info = marriage_day + ", " + marriage_place

                    if(marriageSetting!="none" && d.depth != 0 && d.depth <= 6){
                        if(marriage_info.includes('n/a') || marriage_info.includes('.-') || marriage_info.includes('-.')){
                            d.warning = true;
                        }
                    }
                    
                    if(direction_t=='1'){
                        if(d.depth <= 5){
                            length = Math.floor(treeWidth/ Math.pow(2, d.depth-1) / font_size *1)
                        } else {
                            length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                        }
                    }else if(d.depth == 0){
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)*1.6
                    } else {
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                    }

                    if(d.depth < 6){
                        d3.select(this)
                        .append("tspan")
                        .text( function(){
                            return "Married: ";
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                        var res_text = spliteText(marriage_info, length, 9);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                            .append("tspan")
                            .text(function(){
                                return element;
                            })
                            .attr({
                                x: function(){
                                    if(index > 0) return 0
                                },
                                dy: function(){
                                    if(index > 0) return '1em'
                                },
                                'class': function(){
                                    if(index == 0) return 'nextString'
                                },
                            }) 
                            
                        }
                    } else {
                        d3.select(this)
                        .append("tspan")
                        .text( function(){
                            return "M: ";
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                        var res_text = spliteText(marriage_info, length, 3);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                            .append("tspan")
                            .text(function(){
                                return element;
                            })
                            .attr({
                                x: function(){
                                    if(index > 0) return 0
                                },
                                dy: function(){
                                    if(index > 0) return '1em'
                                },
                                'class': function(){
                                    if(index == 0) return 'nextString'
                                },
                            }) 
                            
                        }
                    }
                   
                }
                if(marriageSetting!="none" && d.depth != 0 && d.depth <= 6){
                    if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                    if(d.depth != 0 && d.depth <= 6) d.height = this.getBBox().height + d.height
                } 
                if(!marriage_height[d.id + d.depth]) marriage_height[d.id + d.depth] = this.getBBox().height   
            });

            function getMarriageDay(d){
                if(d.c_fam){
                    let index = d.c_fam;
                    let temp
                    if(d.marriage[index]){
                        if(d.marriage[index]['dateRange'] ){
                        let from, to
                        if(d.marriage[index]['dateRange'].from ){
                            if(d.marriage[index]['dateRange'].from.qualifier){
                            from = (d.marriage[index]['dateRange'].from.year ? d.marriage[index]['dateRange'].from.year : "-") + (d.marriage[index]['dateRange'].from.qualifier ? "." + d.marriage[index]['dateRange'].from.qualifier : "");
                            }
                            else{
                            from = (d.marriage[index]['dateRange'].from.year ? d.marriage[index]['dateRange'].from.year : "-") + (d.marriage[index]['dateRange'].from.month ? "." + d.marriage[index]['dateRange'].from.month : ".-") + (d.marriage[index]['dateRange'].from.day ? "." + d.marriage[index]['dateRange'].from.day : ".-");
                            }
                        }
                        else{
                            from = "-.-.-";
                        }
                        if(d.marriage[index]['dateRange'].to ){
                            if(d.marriage[index]['dateRange'].to.qualifier){
                            to = (d.marriage[index]['dateRange'].to.year ? d.marriage[index]['dateRange'].to.year : "-") + (d.marriage[index]['dateRange'].to.qualifier ? "." + d.marriage[index]['dateRange'].to.qualifier : "-");
                            }
                            else{
                            to = (d.marriage[index]['dateRange'].to.year ? d.marriage[index]['dateRange'].to.year : "-") + (d.marriage[index]['dateRange'].to.month ? "." + d.marriage[index]['dateRange'].to.month : ".-") + (d.marriage[index]['dateRange'].to.day ? "." + d.marriage[index]['dateRange'].to.day : ".-");
                            }
                        }
                        else{
                            to = "-.-.-";
                        }
                        temp = from + " - " + to;
                        }
                        if(d.marriage[index]['date']){
                        if(d.marriage[index]['date'].qualifier){
                            temp = (d.marriage[index]['date'].year ? d.marriage[index]['date'].year : "-") + (d.marriage[index]['date'].qualifier ? "." + d.marriage[index]['date'].qualifier : "");
                        }
                        else{
                            temp = (d.marriage[index]['date'].year ? d.marriage[index]['date'].year : "-") + (d.marriage[index]['date'].month ? "." + d.marriage[index]['date'].month : ".-") + (d.marriage[index]['date'].day ? "." + d.marriage[index]['date'].day : ".-");
                        }
                        }
                    }
                    else{
                        temp = "-.-.-";
                    }

                    return temp;
                }
            }

// death day and place
            node
                .append("text")
                .attr({
                    "dx": 0,
                    'class': 'death',
                    "text-anchor": "middle",
                    'fill': function(d){
                        if(d.sex=='M') return manColor
                        else return womanColor
                    },
                    'font-size': function(d){
                        if(d.depth <= 9){
                            return textSize[d.depth]
                        } else {
                            return textSize[9]
                        }
                    },
                    "display": function(d){
                        if(d.depth == 0) return "none"
                        if(d.depth > 8){
                            return "none"
                        }
                        if(d.id && d.id.substring(0, 5) == 'fake_'){
                            return empty_node_setting
                        }
                        
                    },
                })
                .each(function(d){
                    let place = d.death ? d.death.place : "n/a";
                    let font_size
                    if(d.depth <= 9){
                        font_size = textSize[d.depth]
                    } else {
                        font_size = textSize[9]
                    } 
                    let death_info = d.deathday + ", " + place

                    if(deathSetting!="none" && d.depth <= 8){
                        if(death_info.includes('n/a') || death_info.includes('.-') || death_info.includes('-.')){
                            d.warning = true;
                        }
                    }

                    if(direction_t=='1'){
                        if(d.depth <= 5){
                            length = Math.floor(treeWidth/ Math.pow(2, d.depth-1) / font_size*1)
                        } else {
                            length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                        }
                    }else if(d.depth == 0){
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)*1.6
                    } else {
                        length = Math.floor((node_width+500*((maxGeneration/2-1) - d.depth))/ font_size * 1.5)
                    }

                    if(d.depth < 6){
                        d3.select(this)
                        .append("tspan")
                        .text( function(){
                            return "Deceased: ";
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                        var res_text = spliteText(death_info, length, 9);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                            .append("tspan")
                            .text(function(){
                                return element;
                            })
                            .attr({
                                x: function(){
                                    if(index > 0) return 0
                                },
                                dy: function(){
                                    if(index > 0) return '1em'
                                },
                                'class': function(){
                                    if(index == 0) return 'nextString'
                                },
                            }) 
                            
                        }
                    } else {
                        d3.select(this)
                        .append("tspan")
                        .text( function(){
                            return "D: ";
                        })
                        .attr({
                            'font-weight': "bold"
                        })
                        var res_text = spliteText(death_info, length, 3);
                        for (let index = 0; index < res_text.length; index++) {
                            const element = res_text[index];
                            d3.select(this)
                            .append("tspan")
                            .text(function(){
                                return element;
                            })
                            .attr({
                                x: function(){
                                    if(index > 0) return 0
                                },
                                dy: function(){
                                    if(index > 0) return '1em'
                                },
                                'class': function(){
                                    if(index == 0) return 'nextString'
                                },
                            }) 
                            
                        }
                    }         
                    
                    if(deathSetting!="none" && d.depth <= 8){
                        if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                        if(d.depth <= 8)d.height = this.getBBox().height + d.height 
                    } 
                    if(!death_height[d.id + d.depth]) death_height[d.id + d.depth] = this.getBBox().height    
                });


             // note
         node
         .append("text")
         .attr({
             "dx": 0,
             'class': 'note',
             'fill': function(d){
                 if(d.sex=='M') return manColor
                 else return womanColor
             },
             'font-size': function(d){
                 if(d.depth <= 9){
                     return textSize[d.depth]/2
                 } else {
                     return textSize[9]/2
                 }
             },
             "display": function(d){
                if(d.depth == 0) return "none"
                 if(d.note=="")  return 'none'
                 else return 'block'
             },
         })
         .each(function(d){
             let note = d.note;
             let font_size
             if(d.depth < 9){
                 font_size = textSize[d.depth]/2
             } else {
                 font_size = textSize[9]/2
             } 

             if(d.depth == 0){
                 length = Math.floor((node_width+450*((maxGeneration/2-1) - d.depth))/ font_size * 1.6)*1.6
             }else if(d.depth >= 8){
                 length = note.length + 2
             } else {
                 length = Math.floor((node_width+450*((maxGeneration/2-1) - d.depth))/ font_size *1.6)
             }
             var res_text = [""]
             if(note != "" && note != null) {
                 
                 
                 res_text = spliteText(note, length, 1);
             }
                 
                 for (let index = 0; index < res_text.length; index++) {
                     const element = res_text[index];
                     d3.select(this)
                     .append("tspan")
                     .text(function(){
                         return element;
                     })
                     .attr({
                         x: function(){
                             return 0
                         },
                         dy: function(){
                             if(index > 0) return '1em'
                         },
                     }) 
                     
                 }
             if(d.note!=""){
                 if(d.width < this.getBBox().width) d.width = this.getBBox().width; 
                 d.height = this.getBBox().height + d.height 
                 note_height[d.id] = this.getBBox().height
             } else {
                 note_height[d.id] = 0
             }
         });

            node.selectAll("tspan").attr({
                dx: function(d){
                    switch (text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1)*d.width/2;                
                        default:
                            return d.width/2; 
                    }
                },
                "text-anchor": text_align,
                opacity: nodeOpacity,
            })     

            node.selectAll(".name_span").attr({
                dx: function(d){
                    switch (name_text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1)*d.width/2;                
                        default:
                            return d.width/2; 
                    }
                },
                "text-anchor": name_text_align,
                opacity: nodeOpacity,
            })  

            node.selectAll(".nextString").attr({
                dx: 0
            })
            
            node.selectAll(".avatar").attr({
                y: function(d){
                    if(d.depth == 0){
                        return (-1)*d.height/2 - (imgSize[0] + 4 * textSize[0])
                    }
                    return (-1)*d.height/2
                },
                opacity: nodeOpacity,
            }) 

            node.selectAll(".flag").attr({
                y: function(d){
                    if(d.depth == 0){
                        return (-1)*d.height/2 - (imgSize[0] + 4 * textSize[0])
                    }
                    return (-1)*d.height/2
                },
                opacity: nodeOpacity,
            }) 
    
            node.selectAll(".name").attr({
                dy: function(d){
                    if(d.depth < 6){
                        return (-1)*d.height/2 + imgSize[d.depth] + textSize[d.depth]
                    } else if(d.depth <= 9) {
                        return (-1)*d.height/2 + textSize[d.depth]
                    } else {
                        return (-1)*d.height/2 + textSize[9]
                    }
                },
                dx: function(d){
                    switch (name_text_align) {
                        case 'middle':
                            return 0;
                        case 'start':
                            return (-1)*d.width/2;                
                        default:
                            return d.width/2; 
                    }
                },
                "transform": function(d){
                    if(d.depth > 5 && direction_t==1){
                        return "rotate(90)"
                    }
                },
                "text-anchor": name_text_align
            }) 
    
            node.selectAll(".birth").attr({
                dy: function(d){
                    if(d.depth < 6){
                        return (-1)*d.height/2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                    } else if(d.depth <= 9) {
                        return (-1)*d.height/2 + textSize[d.depth] + name_height[d.id + d.depth]
                    } else {
                        return (-1)*d.height/2 + textSize[9] + name_height[d.id + d.depth]
                    }
                },
                "transform": function(d){
                    if(d.depth > 5 && direction_t==1){
                        return "rotate(90)"
                    }
                },
                display: function(d){
                    if(d.depth == 0) return "none"
                    if(birthSetting=="none"){
                        return "none"
                    }
                    if(d.depth > 8){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    } 
                }
            }) 
            node.selectAll(".marriage").attr({
                dy: function(d){
                    if(birthSetting=='none'){
                        if(d.depth < 6){
                            return (-1)*d.height/2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                        } else if(d.depth <= 9) {
                            return (-1)*d.height/2 + textSize[d.depth] + name_height[d.id + d.depth]
                        } else {
                            return (-1)*d.height/2 + textSize[9] + name_height[d.id + d.depth]
                        }
                        
                    } else{
                        if(d.depth < 6){
                            return (-1)*d.height/2 + imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        } else if(d.depth <= 9) {
                            return (-1)*d.height/2 + textSize[d.depth] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        } else {
                            return (-1)*d.height/2 + textSize[9] + name_height[d.id + d.depth] + birth_height[d.id + d.depth]
                        }
                    }                    
                },
                "transform": function(d){
                    if(d.depth > 5 && direction_t==1){
                        return "rotate(90)"
                    }
                },
                display: function(d){
                    if(d.depth == 0) return "none"
                    if(marriageSetting=="none"){
                        return "none"
                    }
                    if(d.depth == 0 || d.depth > 6){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }
                }
            }) 
            node.selectAll(".death").attr({
                dy: function(d){
                    var temp = 0
                    if(d.depth < 6){
                        temp = imgSize[d.depth] + textSize[d.depth] + name_height[d.id + d.depth]
                    } else if(d.depth <= 9) {
                        temp = textSize[d.depth] + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[9] + name_height[d.id + d.depth]
                    }
                    
                    if(birthSetting != 'none'){
                        temp += birth_height[d.id + d.depth]
                    }
                    if(marriageSetting != 'none'){
                        if(d.depth > 0 && d.depth < 7){
                            temp += marriage_height[d.id + d.depth]
                        } 
                    }    
                    return (-1)*d.height/2 + temp
                },
                "transform": function(d){
                    if(d.depth > 5 && direction_t==1){
                        return "rotate(90)"
                    }
                },
                display: function(d){
                    if(d.depth == 0) return "none"
                    if(deathSetting=="none"){
                        return "none"
                    }
                    if(d.depth > 8){
                        return "none"
                    }
                    if(d.id && d.id.substring(0, 5) == 'fake_'){
                        return empty_node_setting
                    }
                }
            }) 

            node.selectAll(".note").attr({
                dy: function(d){
                    var temp = 0
                    if(d.depth == 0){
                        if(d.avatar_setting != "SHOW"){
                            temp = textSize[0]/2 + name_height[d.id + d.depth] - (imgSize[0] + 4 * textSize[0])
                        } else {
                            temp = imgSize[0] + textSize[0]/2 + name_height[d.id + d.depth] - (imgSize[0] + 4 * textSize[0])
                        }
                        
                    } else if(d.depth < 6){
                        if(d.avatar_setting != "SHOW"){
                            temp = textSize[d.depth]/2 + name_height[d.id + d.depth]
                        } else {
                            temp = imgSize[d.depth] + textSize[d.depth]/2+ name_height[d.id + d.depth]
                        }
                        
                    } else if(d.depth <= 9) {
                        temp = textSize[d.depth]/2 + name_height[d.id + d.depth]
                    } else {
                        temp = textSize[9]/2 + name_height[d.id + d.depth]
                    }
                    
                    if(birthSetting != 'none' && d.depth < 9){
                        temp += birth_height[d.id + d.depth]
                    }
                    if(marriageSetting != 'none'){
                        if(d.depth > 0 && d.depth < 7){
                            temp += marriage_height[d.id + d.depth]
                        } 
                    }
                    if(deathSetting != 'none' && d.depth < 9){
                        temp += death_height[d.id + d.depth]
                    }
    
                    return (-1)*d.height/2 + temp
                },
            })  

            nodeUpdate
                .select("rect")
                .attr({
                    x: function(d){
                        return -(d.width*1.1 + 20)/2;
                    },
                    y: function(d){
                        return d.depth==0 ? -(d.height + 20)/2-(imgSize[0] + 4 * textSize[0]) : -(d.height + 20)/2;
                    },
                    width: function(d){
                        return d.width*1.1 + 20;
                    },
                    height: function(d){
                        return d.height + 20;
                    },
                    "transform": function(d){
                        if(d.depth > 5 && direction_t==1){
                            return "rotate(90)"
                        }
                    },
                    stroke: function(d){
                        return borderColor
                    } ,       
                    display: function(d){
                        if(d.depth == 0) return "none"
                        if(d.id && d.id.substring(0, 5) == 'fake_'){
                            return empty_node_setting
                        }
                    },
                    rx: function(d) { 
                        return borderRadius; 
                    },
                    "stroke-width": function(d) { 
                        return borderWidth; 
                    },
                    fill: function (d) {
                        if(d.sex=='M') return maleNodeColor
                        else return femaleNodeColor 
                    },
                }).each(function(d){
                    if(d.depth == 0){
                        start_x = -d.x/10
                        start_y = -d.y/10
                    }
                });

            node
                .append('image')
                .attr({
                    'class': 'warning',
                    'xlink:href': function (d) {
                        return GlobalConstants.warning
                    },
                    'width': function(d){
                        if(d.depth>5) return imgSize[5]/d.depth
                        return imgSize[d.depth]/2
                    },
                    'height': function(d){
                        if(d.depth>5) return imgSize[5]/d.depth
                        return imgSize[d.depth]/2
                    },
                    "x": function(d){      
                        if(d.depth>5) return -(d.width*1.1 + 20)/2 - imgSize[5]/d.depth/2
                        return -(d.width*1.1 + 20)/2 -imgSize[d.depth]/4;        
                    },
                    y: function(d){
                        return -(d.height + 20)/2;
                    },
                    "display": function(d){
                        if(d.warning && warning_setting=="SHOW" && d.depth!=0){
                            return 'block';
                        } else {
                            return 'none';
                        }                    
                    },
                    "transform": function(d){
                        if(d.depth > 5 && direction_t==1){
                            return "rotate(90)"
                        }
                    },
                })

            d3
                .select('svg')
                .select('g')
                .attr("transform", "translate("+start_y+","+start_x+") scale(0.1)")
                zoom.translate([start_y, start_x]);

            nodes.forEach(function (person) {
                person.x0 = person.x;
                person.y0 = person.y;
            });
            
        }

        function elbow(d, direction) {
            switch (direction_t) {
                case 3:
                    return "M" + direction * d.source.y + "," + d.source.x + "H" + direction * (d.source.y + (d.target.y - d.source.y) / 2) + "V" + d.target.x + "H" + direction * d.target.y;
                default:
                    return "M" + d.source.x + "," + direction * d.source.y + "V" + direction * (d.source.y + (d.target.y - d.source.y) / 2) + "H" + d.target.x + "V" + direction * d.target.y;
            }
        }

        if(this.children_setting == 'SHOW'){
            this.addchildren(direction_t)
        }
        
    }

    change_size(){
        const dialogConfig = new MatDialogConfig();
        // The user can't close the dialog by clicking outside its body
        dialogConfig.disableClose = true;
        dialogConfig.id = "modal-component";
        dialogConfig.height = "90vh";
        dialogConfig.width = "500px";

        this.matDialog.open(ChangeSizeComponent, dialogConfig);
    }

    ngOnInit() : void {
        d3
            .select('svg')
            .remove() 
        papertype = localStorage.getItem('papertype') ? localStorage.getItem('papertype') : 'A0';
        manColor = localStorage.getItem('manColor') ? localStorage.getItem('manColor') : '#000';
        womanColor = localStorage.getItem('womanColor') ? localStorage.getItem('womanColor') : '#000';;
        borderColor = localStorage.getItem('borderColor') ? localStorage.getItem('borderColor') : '#000';
        maleNodeColor = localStorage.getItem('maleNodeColor') ? localStorage.getItem('maleNodeColor') : '#fff';
        femaleNodeColor = localStorage.getItem('femaleNodeColor') ? localStorage.getItem('femaleNodeColor') : '#fff';
        borderRadius = parseInt(localStorage.getItem('cornerRound') ? localStorage.getItem('cornerRound') : '50') ;
        borderWidth = parseInt(localStorage.getItem('borderWidth') ? localStorage.getItem('borderWidth') : '2') ;
        backOpacity = parseFloat(localStorage.getItem('backOpacity') ? localStorage.getItem('backOpacity') : '1') ;
        nodeOpacity = parseFloat(localStorage.getItem('nodeOpacity') ? localStorage.getItem('nodeOpacity') : '1') ;
        maxGeneration = parseInt(localStorage.getItem('maxGeneration') ? localStorage.getItem('maxGeneration') : '10');
        treeWidth = localStorage.getItem('tree_width') ? localStorage.getItem('tree_width') : 67408;
        treeHeight = localStorage.getItem('tree_height') ? localStorage.getItem('tree_height') : 47679;
        flag_setting = localStorage.getItem('flag_setting') ? localStorage.getItem('flag_setting') : "SHOW";
        this.flag_setting = flag_setting;
        profile_setting = localStorage.getItem('profile_setting') ? localStorage.getItem('profile_setting') : "SHOW";
        this.profile_setting = profile_setting

        warning_setting = localStorage.getItem('warning_setting') ? localStorage.getItem('warning_setting') : "SHOW";
        this.warning_setting = warning_setting

        if(profile_setting=="SHOW"){
            imgSize = imgSizeGroup[papertype]
        } else {
            imgSize = [0,0,0,0,0,0]
        }
        textSize = textSizeGroup[papertype]
        flagSize = flagSizeGroup[papertype]

        this.p_type = papertype
        this.m_Color = manColor
        this.w_Color = womanColor
        this.m_b_Color = maleNodeColor
        this.w_b_Color = femaleNodeColor
        this.b_Color = borderColor
        this.b_Width = borderWidth
        this.back_Opacity = backOpacity
        this.node_Opacity = nodeOpacity
        this.max_generation = maxGeneration
        this.cornerRound = borderRadius

        global_padding = localStorage.getItem('global_padding') ? localStorage.getItem('global_padding') : '5';
        this.global_padding = global_padding

        singleModal = this.matDialog;

        this._id = localStorage.getItem("id");
        this.type = localStorage.getItem("type");
        this.nodeinfos = JSON.parse(localStorage.getItem('nodeinfos'));        
        this.coupleinfos = JSON.parse(localStorage.getItem('coupleinfos'));  
        
        empty_node_setting = localStorage.getItem('empty_node_setting') ? localStorage.getItem('empty_node_setting') : "block";
        this.empty_node = empty_node_setting == "block" ? "SHOW" : "HIDE"

        text_align = localStorage.getItem('text_align') ? localStorage.getItem('text_align') : "middle";
        name_text_align = localStorage.getItem('name_text_align') ? localStorage.getItem('name_text_align') : "middle";

        birthSetting = localStorage.getItem('birth_setting') ? localStorage.getItem('birth_setting') : "block";
        this.birthSetting = birthSetting == "block" ? "SHOW" : "HIDE"

        marriageSetting = localStorage.getItem('marriage_setting') ? localStorage.getItem('marriage_setting') : "block";
        this.marriageSetting = marriageSetting == "block" ? "SHOW" : "HIDE"

        deathSetting = localStorage.getItem('death_setting') ? localStorage.getItem('death_setting') : "block";
        this.deathSetting = deathSetting == "block" ? "SHOW" : "HIDE"

        this.partner_setting = localStorage.getItem('partner_setting') ? localStorage.getItem('partner_setting') : "SHOW";
        this.children_setting = localStorage.getItem('children_setting') ? localStorage.getItem('children_setting') : "SHOW";

        // this.text_align = 
        switch (text_align) {
            case 'start':
                this.text_align = "LEFT"
                break;

            case 'end':
                this.text_align = "RIGHT"
                break;
        
            default:
                this.text_align = "CENTER"
                break;
        }

        switch (name_text_align) {
            case 'start':
                this.name_text_align = "LEFT"
                break;

            case 'end':
                this.name_text_align = "RIGHT"
                break;
        
            default:
                this.name_text_align = "CENTER"
                break;
        }

        if (localStorage.getItem('direction') != null) {
            this.selectTreeType(parseInt(localStorage.getItem('direction')));
        } else {
            this.selectTreeType(1);
        }       
    }
}
